import { useEffect } from 'react';
import { SITE_ORIGIN } from '../data/dgpt';

/** Site-wide Organization and WebSite structured data, plus the poster-image preconnect. */
export function SiteSchema() {
  useEffect(() => {
    const structuredData = {
      '@context': 'https://schema.org',
      '@graph': [{
        '@type': 'Organization',
        '@id': 'https://www.startupfuel.com/#organization',
        name: 'StartupFuel',
        url: 'https://www.startupfuel.com'
      }, {
        '@type': 'WebSite',
        '@id': `${SITE_ORIGIN}/#website`,
        name: 'DiligenceGPT™',
        url: `${SITE_ORIGIN}/`,
        publisher: {
          '@id': 'https://www.startupfuel.com/#organization'
        }
      }]
    };
    let script = document.head.querySelector<HTMLScriptElement>('script[data-site-jsonld]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-site-jsonld', 'true');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(structuredData);

    // Warm up the poster image origin only — the Vimeo player is not contacted until play.
    if (!document.head.querySelector('link[data-dgpt-preconnect]')) {
      const preconnect = document.createElement('link');
      preconnect.rel = 'preconnect';
      preconnect.href = 'https://i.vimeocdn.com';
      preconnect.setAttribute('data-dgpt-preconnect', 'true');
      document.head.appendChild(preconnect);
    }
  }, []);
  return null;
}